import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/gameApi'
import {
  getRankingAchievementSuccess,
  getRankingAchievementFailed,
  GET_RANKING_ACHIEVEMENT_START,
} from '~/views/app/redux/actions/user'

/**
 * get ranking achievement api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */

const getRankingAchievementApi = (props) => {
  var uri = `/api/game/ranked/blockchain/get-by-wallet`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */

function* doGetRankingAchievement(action) {
  try {
    const response = yield call(getRankingAchievementApi, action?.payload)
    yield put(getRankingAchievementSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getRankingAchievementFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}
/**
 * [Watcher]
 * Watch get ranking achievement
 */
export default function* watchGetRankingAchievement() {
  yield takeLatest(GET_RANKING_ACHIEVEMENT_START, doGetRankingAchievement)
}
